export default __webpack_public_path__ + "static/media/image14.9fef2500.jpg";